import { getProduct, getWebOrderDetails, getWebOrderDiscountsDetails } from "../apis/backendRequests";
import { orderActions } from "../actions";

export async function GetDetailOrder(dynamicsId, webOrderId, dispatch) {
    const [orderDetails, discountDetails] = await Promise.all([
        getWebOrderDetails(webOrderId),
        getWebOrderDiscountsDetails(webOrderId)
    ]);

    const productsWithDetails = orderDetails.data.map(async (prod) => {
        const productDetails = await getProduct(prod.productId, dynamicsId);
        const discount = discountDetails.data.find(desc => desc.productId === prod.productId);

        if (productDetails && discount) {
            return {
                ...prod,
                productDescription: productDetails.data.productDescription,
                quantity: prod.quantity,
                discount: discount
            };
        }

        return null;
    }).filter(Boolean);

    const products = await Promise.all(productsWithDetails);

    products.forEach(product => {
        dispatch(orderActions.addItem(product));
    });
}